import { BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';
import { HtMenuService } from '../lib-shared/services/htmenu.service';
import { AuthorizeService } from '../lib-shared/services/authorize.service';
import { UserService } from '../lib-shared/services/user.service';
import { PermissionTypes } from '../lib-shared/vs-constants';
import * as i0 from "@angular/core";
import * as i1 from "../lib-shared/services/htmenu.service";
import * as i2 from "../lib-shared/services/authorize.service";
import * as i3 from "../lib-shared/services/user.service";
// Bản sao giống hệt ở WorkClient/src/app/services/menu-group.service.ts — sửa thì sửa cả hai.
export const MA_NHOM_KHAC = 'OTHER';
export class MenuGroupService {
    constructor(_htMenuService, _authorizeService, _userService) {
        this._htMenuService = _htMenuService;
        this._authorizeService = _authorizeService;
        this._userService = _userService;
        // null = chưa tải xong; [] = không có cấu hình nhóm → sidebar hiện đầy đủ như cũ
        this.phanHes$ = new BehaviorSubject(null);
        // Nhóm đang chọn trên sidebar của app hiện tại
        this.selectedCode$ = new BehaviorSubject(null);
        this._idPhanHe = environment.clientDomain.idPhanhe;
        this._selectedKey = 'htMenuGroup' + environment.clientDomain.idPhanhe;
        this._requestKey = 'htMenuGroupRequest' + environment.clientDomain.idPhanhe;
    }
    /**
     * Gọi ở constructor AppComponent, trước khi đăng nhập: redirect OAuth quay về origin nên mất query string,
     * phải giữ `?nhom=` (app kia gửi sang) vào sessionStorage.
     */
    captureRequestedGroup() {
        const match = /[?&]nhom=([^&#]*)/i.exec(window.location.search || '');
        if (match && match[1]) {
            sessionStorage.setItem(this._requestKey, decodeURIComponent(match[1]).trim().toUpperCase());
        }
    }
    /** Lấy nhóm app kia yêu cầu mở (chỉ dùng một lần). */
    consumeRequestedGroup() {
        const code = sessionStorage.getItem(this._requestKey);
        if (code) {
            sessionStorage.removeItem(this._requestKey);
        }
        return code;
    }
    getCachedGroup() {
        return sessionStorage.getItem(this._selectedKey);
    }
    select(code) {
        if (!code) {
            return;
        }
        sessionStorage.setItem(this._selectedKey, code);
        if (this.selectedCode$.value !== code) {
            this.selectedCode$.next(code);
        }
    }
    /** Gọi sau khi đã nạp quyền (fetchAuthorization). */
    load() {
        return this._htMenuService.getsNhomPhanHe().then(rs => {
            const data = rs && rs.status && rs.data ? rs.data : [];
            const phanHes = this.buildPhanHes(data);
            this.phanHes$.next(phanHes);
            return phanHes;
        }, () => {
            this.phanHes$.next([]);
            return [];
        });
    }
    getCurrentPhanHe() {
        const phanHes = this.phanHes$.value || [];
        return phanHes.find(x => x.laAppHienTai) || null;
    }
    /** Mã nhóm của một menu cấp 1 trong app hiện tại; mã không còn hoạt động → "Khác". */
    getMenuGroupCode(item) {
        const current = this.getCurrentPhanHe();
        const code = item && item.maNhomPhanHe ? item.maNhomPhanHe.toString().trim().toUpperCase() : null;
        if (!code || !current || current.maNhoms.indexOf(code) < 0) {
            return MA_NHOM_KHAC;
        }
        return code;
    }
    buildGroupUrl(phanHe, nhom) {
        return phanHe.url + '/?nhom=' + encodeURIComponent(nhom.ma);
    }
    /** Cùng cách kiểm tra quyền với directive [authorize] + isNavigationPermission trên sidebar. */
    isGranted(phanQuyen) {
        const user = this._userService.getBasicUserInfo();
        if (user && user.issuperuser) {
            return true;
        }
        let required = phanQuyen;
        if (required) {
            try {
                required = JSON.parse(required.toString().replace(/'/g, '"'));
            }
            catch (ex) {
                // directive cũng giữ nguyên chuỗi không parse được
            }
        }
        if (required instanceof Array) {
            return required.some(item => this._authorizeService.validated(item, PermissionTypes.PAGE));
        }
        return this._authorizeService.validated(required, PermissionTypes.PAGE);
    }
    buildPhanHes(data) {
        const urls = environment.clientDomain.phanHeUrls || {};
        return (data || [])
            .map(item => {
            const laAppHienTai = item.phanHe === this._idPhanHe;
            const url = laAppHienTai ? window.location.origin : (urls[item.phanHe] || '');
            const nhoms = (item.nhoms || [])
                .filter(nhom => (nhom.phanQuyens || []).some(pq => this.isGranted(pq)));
            return {
                phanHe: item.phanHe,
                tenPhanHe: item.tenPhanHe,
                url: url ? url.replace(/\/+$/, '') : '',
                laAppHienTai: laAppHienTai,
                maNhoms: (item.nhoms || []).map(nhom => nhom.ma).filter(ma => ma !== MA_NHOM_KHAC),
                nhoms: nhoms
            };
        })
            .filter(item => item.laAppHienTai || (item.url && item.nhoms.length));
    }
}
MenuGroupService.ngInjectableDef = i0.defineInjectable({ factory: function MenuGroupService_Factory() { return new MenuGroupService(i0.inject(i1.HtMenuService), i0.inject(i2.AuthorizeService), i0.inject(i3.UserService)); }, token: MenuGroupService, providedIn: "root" });
